import { styled, MobileStepper, Paper, Button } from '@mui/material';

export const StyledPaper = styled(Paper)(() => ({
  padding: '16px',
  borderRadius: '16px',
  backgroundColor: '#F5F5F4',
  boxShadow: 'none',
  border: '1px solid',
  borderColor: '#ADADAD8A',
}));

export const SummaryMobileStepper = styled(MobileStepper)(({ theme }) => ({
  width: '100%',
  background: 'transparent',
  padding: 0,
  '& .MuiMobileStepper-progress': {
    width: '100%',
    height: 14,
    borderRadius: '60px',
    backgroundColor: '#E5E7EB',
    '& .MuiLinearProgress-bar': {
      backgroundColor: theme.palette.primary.main,
      borderRadius: '60px',
    },
  },
}));

export const OutlinedButton = styled(Button)(({ theme }) => ({
  width: '220px',
  fontWeight: '600',
  borderRadius: '10px',
  display: 'flex',
  gap: '8px',
  color: theme.palette.primary.dark,
  backgroundColor: 'transparent',
  border: `1.5px solid ${theme.palette.primary.dark}`,
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
  '&:disabled': {
    color: theme.palette.primary.dark,
  },
  '&:active': {
    backgroundColor: theme.palette.primary.dark,
  },
  span: {
    fontSize: '20px',
  },
}));
